import { useLocation } from 'react-router-dom';

function useLocationState<State>() {
  const location = useLocation();
  return location.state as ExpectedAny as State | null;
}

export default useLocationState;
